import React, {useEffect, useState} from 'react';
import {AiOutlineArrowDown, AiOutlineArrowUp} from "react-icons/ai";
import WasteItems from "./Components/Waste-Items/Waste-Items";
import WasteLevelsChart from "./Components/Waste-Levels-Chart/Waste-Levels-Chart";
import axiosInstance from "../../api/axios";
import {useTranslation} from "react-i18next";

const Waste = ({
                   id,
                   currentWasteItem,
                   dayvalue,
                   language,
                   message,
                   selectedButton,
                   totalwasteproduced,
                   colorwaste,
                   percentagechange,
                   TotalWasteWeight,
                   selectedValue,
                   setSelectedValue,
                   datevalue
               }) => {

        const [totalwasteproduceddata, setTotalWasteProducedData] = useState('');
        const [wasteweight, setWasteWeight] = useState(TotalWasteWeight);
        const [colorwastechart, setColorWasteChart] = useState();
        const [percentagechangewastechart, setPercentageChangeWasteChart] = useState();
        const [binpk, setBinPk] = useState();
        const {t} = useTranslation();


        const handleTotalWasteProducedData = (data) => {
            setTotalWasteProducedData(data);
        };

        const updateTotalWasteWeight = (newWeight) => {
            setWasteWeight(newWeight);
        };

        const filterlang = () => {

            if (selectedButton === 'year' && '') {
                return "jaar";
            }

            if (selectedButton === '6months') {
                return "6 maanden";
            }

            if (selectedButton === '3months') {
                return "3 maanden";
            }

            if (selectedButton === 'month') {
                return "maanden";
            }

            if (selectedButton === 'week') {
                return "week";
            }

            if (selectedButton === 'day') {
                return "dag";
            }

            if (selectedButton === 'custom') {
                return "aangepast";
            }
        };


        useEffect(() => {
            const fetchData = async () => {
                try {
                    const binResponse = await axiosInstance.get('/get_bins');
                    const foundData = binResponse.data.find(item => item.unique_identifier === id);
                    console.log('binPK ', foundData);
                    setBinPk(foundData?.id);

                    if (foundData?.id) {
                        const wasteResponse = await axiosInstance.get(`/wastebarchart/${foundData.id}/${dayvalue}`, {
                            params: {
                                wasteitem: currentWasteItem,

                            }
                        });
                        setPercentageChangeWasteChart(parseFloat(wasteResponse.data?.percentage_change).toFixed(2));
                        setColorWasteChart(wasteResponse.data?.color);
                        setTotalWasteProducedData(wasteResponse.data?.objects);
                        setWasteWeight(wasteResponse.data?.waste_weight);
                    }
                } catch (error) {
                    console.error(error);
                }
            };

            fetchData();
        }, [currentWasteItem, id, dayvalue]);


        return (
            <div className="min-h-screen bg-white dark:bg-plaex-dark dark:text-white">
                <div className="w-full px-8 py-4 pt-16 mt-4 sm:mt-70">
                    {/* Waste Level Chart  */}
                    <div className="flex flex-col items-center justify-center w-full mb-4">
                        <h2 className="text-2xl font-poppins font-semibold text-center ">
                            {t('totalwastecomparison')} {filterlang()}
                        </h2>
                        <div className="flex items-center justify-center gap-4 mt-2">
                        <span className="font-semibold text-base">
                            {totalwasteproduceddata} <span className="font-light">{t('objectslabel')}</span> | {wasteweight}
                            <span className="font-light"> KG</span>
                        </span>
                            <span className={`text-${colorwastechart}-500 flex items-center justify-center text-sm font-semibold`}>
                            {percentagechangewastechart}% {colorwastechart === "red" ?
                                <AiOutlineArrowUp/> :
                                <AiOutlineArrowDown/>}
                        </span>
                        </div>
                    </div>

                    <div className="relative mb-8">
                        <WasteLevelsChart id={id} wasteitem={currentWasteItem} dayvalue={dayvalue}
                                          handleTotalWasteProducedData={handleTotalWasteProducedData}
                                          datevalue_={datevalue}/>
                    </div>

                    {setSelectedValue(selectedButton)}

                    {/* Waste Items Table  */}
                    <div className="mb-8">
                        <h2 className="text-2xl font-poppins font-semibold mb-4 text-center">
                            {t('wasteitemslabel')}
                        </h2>
                        <WasteItems id={id} value={selectedValue} wastevalue={currentWasteItem} datevalue_={datevalue}
                                    selectedButton_={selectedButton}/>
                    </div>
                </div>
            </div>
        );
    }
;

export default Waste;